import { SVGProps } from 'react';

const Boat4YouNeutral = ({
  props,
  size = 64,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#161616" rx="32" />
    <path
      fill="#888"
      fillRule="evenodd"
      d="M16.293 34.434a15.254 15.254 0 0 1 1.732-10.557 15.6 15.6 0 0 1 5.81-5.785A15.956 15.956 0 0 1 31.826 16a15.95 15.95 0 0 1 7.969 2.18 15.59 15.59 0 0 1 5.744 5.848 15.249 15.249 0 0 1 1.613 10.575 15.312 15.312 0 0 1-2.093 5.102l-4.596-2.843.002-.003a10.003 10.003 0 0 0 1.578-5.089 9.988 9.988 0 0 0-1.266-5.176 10.212 10.212 0 0 0-3.762-3.83 10.447 10.447 0 0 0-5.219-1.427 10.45 10.45 0 0 0-5.235 1.37 10.217 10.217 0 0 0-3.805 3.79 9.99 9.99 0 0 0-1.324 5.16 10 10 0 0 0 1.522 5.11l-4.628 2.792a15.306 15.306 0 0 1-2.034-5.124Z"
      clipRule="evenodd"
    />
    <path
      fill="#888"
      fillRule="evenodd"
      d="m32.346 33.777 13.803 8.866c1.336.858 1.733 2.652.887 4.007a2.84 2.84 0 0 1-3.951.9l-10.74-6.898-10.738 6.897a2.84 2.84 0 0 1-3.95-.9c-.847-1.354-.45-3.148.886-4.006l13.803-8.866Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Boat4YouNeutral;
